
  import prepareLinkItem from '@/mixins/prepareLinkItem';
  export default {
    mixins: [prepareLinkItem],
    props: {
      sheetElements: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        links: [],
      };
    },
    created() {
      const preparedLinks = [];
      this.sheetElements.forEach((link) => {
        preparedLinks.push(this.prepareLinkItem(link));
      });
      this.links = preparedLinks;
    },
  };
